import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './welcome.css'
import WelcomeApp from './WelcomeApp'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WelcomeApp />
  </StrictMode>,
)
